import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setView } from '../../../redux/actions/setFilters'
import { views } from '../../../configuration/views'
import activeCalendarView from '../../../assets/icons/view-calendar-active.svg'
import calendarView from '../../../assets/icons/view-calendar.svg'
import activeGridView from '../../../assets/icons/view-grid-active.svg'
import gridView from '../../../assets/icons/view-grid.svg'

const ViewFilter = () => {
  const currentView = useSelector((state) => state.filtersData.view)
  const dispatch = useDispatch()
  const [calendarIcon, setCalendarIcon] = useState(activeCalendarView)
  const [gridIcon, setGridIcon] = useState(gridView)

  useEffect(() => {
    if (currentView === views.monthly) {
      setCalendarIcon(activeCalendarView)
      setGridIcon(gridView)
    } else {
      setCalendarIcon(calendarView)
      setGridIcon(activeGridView)
    }
  }, [currentView])

  const handleClick = (view) => {
    dispatch(setView(view))
  }

  return (
    <div className="decoupled-events__filters-bar-view">
      <button
        className={`btn btn-filters-view ${currentView !== views.monthly ? 'active' : ''}`}
        onClick={() => handleClick(views.weekly)}
      >
        <img src={gridIcon} alt="grid-view" />
      </button>
      <button
        className={`btn btn-filters-view ${currentView === views.monthly ? 'active' : ''}`}
        onClick={() => handleClick(views.monthly)}
      >
        <img src={calendarIcon} alt="calendar-view" />
      </button>
    </div>
  )
}

export default ViewFilter
